




import { IActivity, ILesson } from "@/models/interfaces/lessons";
import { IVuexState } from "@/models/interfaces/store";
import { Vue, Component } from "vue-property-decorator";
import { Action, State } from "vuex-class";

import ActivityThumbnails from "@/components/ActivityThumbnails/ActivityThumbnails.vue";

@Component({
  components: {
    ActivityThumbnails
  }
})
export default class ReportThumbnails extends Vue {
  @Action("lessons/fetchActivitiesForLesson")
  private fetchActivitiesForLesson!: (lessonId: string) => Promise<IActivity[]>;

  @State("lessonData", { namespace: "lessons" })
  private lessonData!: IVuexState<{
    activities: IActivity[];
    lesson: ILesson;
  }>;

  public mounted() {
    this.fetchActivitiesForLesson(this.$route.params.lessonId);
  }
}
